import { createSelector} from 'reselect'

const selectAuth = (state) => state.auth

export const selectIsAuthenticated = createSelector(
  [selectAuth],
  auth => auth.isAuthenticated
)

export const selectUserAuth = createSelector(
  [selectAuth],
  auth => auth.userAuth
)

export const selectSignup = createSelector(
  [selectAuth],
  auth => auth.signup
)

export const selectLoading = createSelector(
  [selectAuth],
  auth => auth.loading
)

export const selectAuthError = createSelector(
  [selectAuth],
  auth => auth.error
)